import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { initAnalytics, trackEvent, trackPageview } from './analytics'
import './index.css'

function publishLayout() {
  const root = document.documentElement
  root.dataset.layout = `${window.innerWidth}x${root.scrollWidth}`
}

initAnalytics()
trackPageview(window.location.pathname)
if (new URLSearchParams(window.location.search).get('owner_check') === '1') {
  trackEvent('owner_check')
}

publishLayout()
window.addEventListener('load', publishLayout)
window.addEventListener('resize', publishLayout)
document.fonts?.ready.then(publishLayout)
requestAnimationFrame(() => requestAnimationFrame(publishLayout))

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
